import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { TransformationSection } from './components/TransformationSection';
import { TomosSection } from './components/TomosSection';
import { AudienceSection } from './components/AudienceSection';
import { AuthorSection } from './components/AuthorSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { PurchaseToast } from './components/PurchaseToast';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-white font-sans text-ink" data-id="element-0" data-mp="28sb9kymlev40">
      <main data-id="element-1" data-mp="23u9uspw79hyc">
        <Hero data-id="element-2" data-mp="23ujha3i1d6za" />
        <PainSection data-id="element-3" data-mp="23v2tr4ox335x" />
        <TransformationSection data-id="element-4" data-mp="3ijxpcqos80jw" />
        <TomosSection data-id="element-5" data-mp="3ikqyfyb7r257" />
        <AudienceSection data-id="element-6" data-mp="3ij61k21ff746" />
        <OfferSection data-id="element-7" data-mp="3ihv1ac76whht" />
        <GuaranteeSection data-id="element-8" data-mp="3mlavl1vse5rc" />
        <AuthorSection data-id="element-9" data-mp="3mkhlbqxmcy4g" />
        <TestimonialsSection data-id="element-10" data-mp="3mjztd6hzp62c" />
        <FaqSection data-id="element-11" data-mp="3mj6lu3b7icj5" />
        <FinalCta data-id="element-12" data-mp="3rbra6pbcfxfa" />
      </main>

      <footer className="w-full border-t border-cream-deep bg-white py-8" data-id="element-13" data-mp="3rdkh85pvcjnt">
        <div className="mx-auto flex max-w-content flex-col items-center justify-between gap-3 px-6 text-sm text-ink-muted sm:flex-row" data-id="element-14" data-mp="67yvnd9206b">
          <p data-id="element-15" data-mp="2zmwj72jhrued">Megapack para Entrenadores de Running</p>
          <p data-id="element-16" data-mp="33m5bs42spm8c">Material 100% digital · Acceso de por vida</p>
        </div>
      </footer>
    </div>;
}